export default "__VITE_ASSET__DbpuNmwm__"